import type { FormikSharedConfig, FormikState, FormikValues } from "@byko/lib-formik";

export const showFormikError = (formik: FormikState<FormikValues> & FormikSharedConfig, field: string): boolean => {
  const touched = formik.touched[field];
  const error = formik.errors[field];

  return Boolean(touched && error);
};
